import React from 'react'

const UspBanner = ({ contentfulTranslations }) => {
  if (!contentfulTranslations) return null

  return <div className='mxd-shop-usp' dangerouslySetInnerHTML={{ __html: contentfulTranslations }} />
}

export default UspBanner
